import { render, staticRenderFns } from "./StatusForm.vue?vue&type=template&id=2313722c&"
import script from "./StatusForm.vue?vue&type=script&lang=js&"
export * from "./StatusForm.vue?vue&type=script&lang=js&"
import style0 from "./StatusForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports